"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePromocodeDto = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const constants_1 = require("../../constants");
const promocode_condition_values_dto_1 = require("./promocode-condition-values.dto");
const promocode_logic_value_dto_1 = require("./promocode-logic-value.dto");
class CreatePromocodeDto {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreatePromocodeDto.prototype, "code", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreatePromocodeDto.prototype, "headline", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreatePromocodeDto.prototype, "title", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreatePromocodeDto.prototype, "buttonText", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreatePromocodeDto.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreatePromocodeDto.prototype, "descriptionHeadline", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(constants_1.PROMOCODE_CONDITION_TYPE),
    __metadata("design:type", String)
], CreatePromocodeDto.prototype, "condition", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => promocode_condition_values_dto_1.PromocodeConditionValuesDto),
    __metadata("design:type", promocode_condition_values_dto_1.PromocodeConditionValuesDto)
], CreatePromocodeDto.prototype, "conditionValue", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsEnum)(constants_1.PROMOCODE_LOGIC_TYPE),
    __metadata("design:type", String)
], CreatePromocodeDto.prototype, "logicType", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNotEmptyObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => promocode_logic_value_dto_1.PromocodeLogicValueDto),
    __metadata("design:type", promocode_logic_value_dto_1.PromocodeLogicValueDto)
], CreatePromocodeDto.prototype, "logicValue", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsEnum)(constants_1.PROMOCODE_AVAILABILITY_TYPE, { each: true }),
    __metadata("design:type", Array)
], CreatePromocodeDto.prototype, "availabilities", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsEnum)(constants_1.PROMOCODE_EXPIRATION_TYPE, { each: true }),
    __metadata("design:type", Array)
], CreatePromocodeDto.prototype, "expirationTypes", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], CreatePromocodeDto.prototype, "expirationValues", void 0);
exports.CreatePromocodeDto = CreatePromocodeDto;
//# sourceMappingURL=create-promocode.dto.js.map